var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "portlet light portlet-fit quote-details-portlet",
        on: { keydown: _vm.downKeyAdd },
      },
      [
        _c("div", { staticClass: "portlet-title" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          !_vm.readOnly
            ? _c("div", { staticStyle: { "text-align": "right" } }, [
                _vm.priceIsVisible
                  ? _c(
                      "a",
                      {
                        staticClass: "btn green",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.togglePriceVisibility },
                      },
                      [
                        _c("span", { staticClass: "fa fa-check-square-o" }),
                        _vm._v(" Visibilité prix "),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "btn red",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.togglePriceVisibility },
                      },
                      [
                        _c("span", { staticClass: "fa fa-square-o" }),
                        _vm._v(" Visibilité prix "),
                      ]
                    ),
              ])
            : _c("div", { staticStyle: { "text-align": "right" } }, [
                _vm.priceIsVisible
                  ? _c(
                      "a",
                      {
                        staticClass: "btn green",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.togglePriceVisibility },
                      },
                      [
                        _c("span", { staticClass: "fa fa-check-square-o" }),
                        _vm._v(" Visibilité prix "),
                      ]
                    )
                  : _c(
                      "a",
                      {
                        staticClass: "btn red",
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.togglePriceVisibility },
                      },
                      [
                        _c("span", { staticClass: "fa fa-square-o" }),
                        _vm._v(" Visibilité prix "),
                      ]
                    ),
              ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _vm.loading
            ? _c("div", [_vm._m(2)])
            : _c("div", [
                _c(
                  "table",
                  {
                    staticClass: "table table-bordered",
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: { id: "quote-details-table" },
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                        _vm._v(" "),
                        !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                        _vm._v(" "),
                        _c("th", { staticClass: "width-min-nowrap" }, [
                          _vm._v("Choisi"),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Items")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Description")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Fournisseur")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "width-min-nowrap" }, [
                          _vm._v("Stock"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "width-min-nowrap" }, [
                          _vm._v("Quantité"),
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _vm.priceIsVisible
                          ? _c("th", { staticClass: "width-min-nowrap" }, [
                              _vm._v("$ coutant"),
                              _c("wbr"),
                              _vm._v("unitaire"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.priceIsVisible
                          ? _c(
                              "th",
                              {
                                staticClass: "text-left",
                                staticStyle: { "max-width": "83px" },
                              },
                              [_vm._v("Profit $ min")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.priceIsVisible
                          ? _c("th", { staticClass: "width-min-nowrap" }, [
                              _vm._v("Profit %"),
                              _c("wbr"),
                              _vm._v("min"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _vm.priceIsVisible
                          ? _c("th", { staticClass: "width-min-nowrap" }, [
                              _vm._v("Profit %"),
                              _c("wbr"),
                              _vm._v("réel"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("S-Total")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("Total")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        attrs: { tag: "tbody", handle: ".draggable-handle" },
                        on: { update: _vm.saveItems },
                        model: {
                          value: _vm.items,
                          callback: function ($$v) {
                            _vm.items = $$v
                          },
                          expression: "items",
                        },
                      },
                      _vm._l(_vm.items, function (item, index) {
                        return _c(
                          "tr",
                          {
                            key: index,
                            staticClass: "item-row",
                            class: {
                              "item-unselected": !item.quote_detail_selected,
                              "item-subtotal": item.quote_detail_row_subtotal,
                            },
                          },
                          [
                            !_vm.readOnly
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "width-min-nowrap draggable-handle",
                                    staticStyle: {
                                      padding: "3px 8px",
                                      "vertical-align": "middle",
                                      "font-size": "22px",
                                      cursor: "move",
                                    },
                                  },
                                  [_c("i", { staticClass: "fa fa-bars" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.readOnly
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap",
                                    staticStyle: { padding: "3px 8px" },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-circle btn-icon-only btn-default tooltips",
                                        attrs: {
                                          "data-container": "body",
                                          "data-placement": "top",
                                          "data-original-title": "Supprimer",
                                          href: "javascript:;",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(index)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "icon-trash" })]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", { staticClass: "width-min-nowrap cb" }, [
                              !item.quote_detail_row_subtotal
                                ? _c("div", [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_selected,
                                                expression:
                                                  "item.quote_detail_selected",
                                              },
                                            ],
                                            staticClass:
                                              "quote_detail_selected",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                item.quote_detail_selected
                                              )
                                                ? _vm._i(
                                                    item.quote_detail_selected,
                                                    null
                                                  ) > -1
                                                : item.quote_detail_selected,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      item.quote_detail_selected,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "quote_detail_selected",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "quote_detail_selected",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      item,
                                                      "quote_detail_selected",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                _vm.handleChange,
                                              ],
                                            },
                                          }),
                                        ])
                                      : _c("div", [
                                          item.quote_detail_selected
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-check-square-o",
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              })
                                            : _c("i", {
                                                staticClass: "fa fa-square-o",
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              }),
                                        ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "input",
                                    staticStyle: {
                                      width: "350px",
                                      "min-width": "350px",
                                    },
                                  },
                                  [
                                    !_vm.readOnly
                                      ? _c(
                                          "div",
                                          [
                                            _c("select-two-items", {
                                              ref: "select2-item-" + index,
                                              refInFor: true,
                                              attrs: {
                                                id: "select2-item-" + index,
                                                endpoint: _vm.itemEndpoint,
                                                type: "all",
                                                "initial-value": item
                                                  .quote_detail_item.id
                                                  ? item.quote_detail_item.id.toString()
                                                  : "",
                                                "initial-display":
                                                  item.quote_detail_item.text,
                                                "add-form-base-end-point":
                                                  _vm.baseEndpoint +
                                                  "quote_item/add",
                                                "add-form-title":
                                                  "Ajout d'un item",
                                                "add-form-selector":
                                                  "#form_quote_item",
                                                "add-text-input-selector":
                                                  "#quote_item_name",
                                                "edit-form-base-end-point":
                                                  _vm.baseEndpoint +
                                                  "quote_item/edit",
                                                "edit-form-title":
                                                  "Modifier un item",
                                                "edit-form-selector":
                                                  "#form_quote_item",
                                                "edit-text-input-selector":
                                                  "#quote_item_name",
                                                "allow-add": _vm.allowAddItems,
                                                "allow-edit":
                                                  _vm.allowEditItems,
                                              },
                                              on: {
                                                selected: function ($event) {
                                                  return _vm.onSelect(
                                                    index,
                                                    $event
                                                  )
                                                },
                                                clear: function ($event) {
                                                  return _vm.onClear(index)
                                                },
                                              },
                                              model: {
                                                value: item.quote_detail_item,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "quote_detail_item",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.quote_detail_item",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          { staticStyle: { padding: "5px" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_item.text
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _c(
                                  "td",
                                  {
                                    staticClass: "bold",
                                    staticStyle: {
                                      width: "350px",
                                      "min-width": "350px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Sous-Total\n                  "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.quote_detail_row_subtotal,
                                          expression:
                                            "item.quote_detail_row_subtotal",
                                        },
                                      ],
                                      attrs: { type: "hidden" },
                                      domProps: {
                                        value: item.quote_detail_row_subtotal,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            item,
                                            "quote_detail_row_subtotal",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                            _vm._v(" "),
                            _c("td", { staticClass: "input" }, [
                              !_vm.readOnly
                                ? _c("div", [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.quote_detail_description,
                                          expression:
                                            "item.quote_detail_description",
                                        },
                                      ],
                                      ref: "description-box",
                                      refInFor: true,
                                      staticClass: "form-control",
                                      staticStyle: {
                                        width: "100%",
                                        height: "35px",
                                        "min-height": "35px",
                                        resize: "vertical",
                                      },
                                      domProps: {
                                        value: item.quote_detail_description,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleChangeLine(item)
                                        },
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item,
                                              "quote_detail_description",
                                              $event.target.value
                                            )
                                          },
                                          _vm.autoResize,
                                        ],
                                      },
                                    }),
                                  ])
                                : _c("div", {
                                    staticStyle: { padding: "5px" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.quote_detail_description.replace(
                                          /\n/g,
                                          "<br>"
                                        )
                                      ),
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "input",
                                staticStyle: {
                                  width: "150px",
                                  "max-width": "150px",
                                },
                              },
                              [
                                !_vm.readOnly && !item.quote_detail_row_subtotal
                                  ? _c(
                                      "div",
                                      [
                                        _c("select-two-suppliers", {
                                          attrs: {
                                            id: "select2-supplier-" + index,
                                            endpoint: _vm.supplierEndpoint,
                                            "initial-value":
                                              item.quote_detail_supplier.id,
                                            "initial-display":
                                              item.quote_detail_supplier.text,
                                          },
                                          on: {
                                            selected: function ($event) {
                                              return _vm.onSelectSupplier(
                                                index,
                                                $event
                                              )
                                            },
                                            clear: function ($event) {
                                              return _vm.onClearSupplier(index)
                                            },
                                          },
                                          model: {
                                            value: item.quote_detail_supplier,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "quote_detail_supplier",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.quote_detail_supplier",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.quote_detail_supplier.text
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  { staticClass: "width-min-nowrap cb" },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_in_stock,
                                                expression:
                                                  "item.quote_detail_in_stock",
                                              },
                                            ],
                                            staticClass:
                                              "quote_detail_in_stock",
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                item.quote_detail_in_stock
                                              )
                                                ? _vm._i(
                                                    item.quote_detail_in_stock,
                                                    null
                                                  ) > -1
                                                : item.quote_detail_in_stock,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      item.quote_detail_in_stock,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          item,
                                                          "quote_detail_in_stock",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          item,
                                                          "quote_detail_in_stock",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      item,
                                                      "quote_detail_in_stock",
                                                      $$c
                                                    )
                                                  }
                                                },
                                                _vm.handleChange,
                                              ],
                                            },
                                          }),
                                        ])
                                      : _c("div", [
                                          item.quote_detail_in_stock
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-check-square-o",
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              })
                                            : _c("i", {
                                                staticClass: "fa fa-square-o",
                                                staticStyle: {
                                                  "font-size": "18px",
                                                },
                                              }),
                                        ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: { width: "78px" },
                                  },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: item.quote_detail_qty,
                                                expression:
                                                  "item.quote_detail_qty",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_qty select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "5px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "number" },
                                            domProps: {
                                              value: item.quote_detail_qty,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleChangePricing(
                                                  index,
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_qty",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.quote_detail_qty) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("$")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_suggested_price,
                                                expression:
                                                  "item.quote_detail_suggested_price",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_suggested_price text-right select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                item.quote_detail_suggested_price,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.fixPrice(
                                                  item,
                                                  index,
                                                  $event.target
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.handleChangePricing(
                                                  index,
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_suggested_price",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_suggested_price
                                                ) +
                                                " $\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal &&
                            _vm.priceIsVisible
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("$")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_cost_price,
                                                expression:
                                                  "item.quote_detail_cost_price",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_cost_price text-right select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                item.quote_detail_cost_price,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.fixPrice(
                                                  item,
                                                  index,
                                                  $event.target
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.handleChangePricing(
                                                  index,
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_cost_price",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_cost_price
                                                ) +
                                                " $\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal &&
                            _vm.priceIsVisible
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("$")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_profit_minimum,
                                                expression:
                                                  "item.quote_detail_profit_minimum",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_profit_minimum text-right select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                item.quote_detail_profit_minimum,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.fixPrice(
                                                  item,
                                                  index,
                                                  $event.target
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.handleChangePricing(
                                                  index,
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_profit_minimum",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_profit_minimum
                                                ) +
                                                " $\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal &&
                            _vm.priceIsVisible
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("%")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_profit_percentage,
                                                expression:
                                                  "item.quote_detail_profit_percentage",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_profit_percentage text-right select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                item.quote_detail_profit_percentage,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.fixPrice(
                                                  item,
                                                  index,
                                                  $event.target
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.handleChangePricing(
                                                  index,
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_profit_percentage",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_profit_percentage
                                                ) +
                                                " %\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("$")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.quote_detail_selling_price,
                                                expression:
                                                  "item.quote_detail_selling_price",
                                              },
                                            ],
                                            staticClass:
                                              "form-control quote_detail_selling_price text-right select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                item.quote_detail_selling_price,
                                            },
                                            on: {
                                              blur: function ($event) {
                                                return _vm.fixPrice(
                                                  item,
                                                  index,
                                                  $event.target
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.handleChangeLine(
                                                  item
                                                )
                                              },
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "quote_detail_selling_price",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  item.quote_detail_selling_price
                                                ) +
                                                " $\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal &&
                            _vm.priceIsVisible
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap input",
                                    staticStyle: {
                                      width: "78px",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    !_vm.readOnly &&
                                    !item.quote_detail_row_subtotal
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "8px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("%")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass:
                                              "form-control text-right quote_detail_profit_percentage_real select-on-focus",
                                            staticStyle: {
                                              width: "78px",
                                              "padding-right": "20px",
                                              "padding-left": "5px",
                                            },
                                            attrs: {
                                              type: "text",
                                              disabled: "",
                                            },
                                            domProps: {
                                              value:
                                                _vm.getItemProfitPercent(item),
                                            },
                                          }),
                                        ])
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "5px",
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getItemProfitPercent(item)
                                                ) +
                                                " %\n                "
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap text-right",
                                    staticStyle: { "min-width": "70px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getItemSubtotal(item)) +
                                        " $\n              "
                                    ),
                                  ]
                                )
                              : _c(
                                  "td",
                                  {
                                    staticClass: "bold text-right",
                                    attrs: { colspan: "9" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getSubTotal(index)) +
                                        " $\n              "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            !item.quote_detail_row_subtotal
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap text-right",
                                    staticStyle: { "min-width": "70px" },
                                    style: {
                                      "text-decoration":
                                        item.quote_detail_selected
                                          ? "none"
                                          : "line-through",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getItemTotal(item)) +
                                        " $\n              "
                                    ),
                                  ]
                                )
                              : _c(
                                  "td",
                                  {
                                    staticClass:
                                      "width-min-nowrap bold text-right",
                                    staticStyle: { "min-width": "70px" },
                                    style: {
                                      "text-decoration":
                                        item.quote_detail_selected
                                          ? "none"
                                          : "line-through",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.getTotal(index)) +
                                        " $\n              "
                                    ),
                                  ]
                                ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticStyle: { float: "left" } }, [
                    !_vm.readOnly
                      ? _c(
                          "button",
                          {
                            staticClass: "btn purple",
                            on: { click: _vm.addItem },
                          },
                          [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" Ajouter une ligne"),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { float: "left", "margin-left": "10px" } },
                    [
                      !_vm.readOnly
                        ? _c(
                            "button",
                            {
                              staticClass: "btn purple",
                              on: { click: _vm.addSubtotal },
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus" }),
                              _vm._v(" Ajouter un sous-total"),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { float: "right" } }, [
                    _c("table", { staticClass: "table-bordered text-right" }, [
                      _c("tr", [
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v("Total sans taxes:"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v(_vm._s(_vm.round(_vm.subtotal, 2)) + " $"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v("Montant taxable TPS:"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v(
                            _vm._s(_vm.round(_vm.taxableTpsAmount, 2)) + " $"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v("TPS (" + _vm._s(_vm.tpsValue) + " %):"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v(_vm._s(_vm.round(_vm.tpsAmount, 2)) + " $"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v("Montant taxable TVQ:"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v(
                            _vm._s(_vm.round(_vm.taxableTvqAmount, 2)) + " $"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v("TVQ (" + _vm._s(_vm.tvqValue) + " %):"),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticStyle: { padding: "5px" } }, [
                          _vm._v(_vm._s(_vm.round(_vm.tvqAmount, 2)) + " $"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "5px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v("Total:")]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "5px",
                              "min-width": "100px",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(_vm.round(_vm.grandTotal, 2)) + " $")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "caption" }, [
      _c("i", { staticClass: "fa fa-list" }),
      _vm._v(" "),
      _c("span", { staticClass: "caption-subject bold uppercase" }, [
        _vm._v("Services et pièces"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tools" }, [
      _c("a", {
        staticClass: "collapse",
        attrs: {
          href: "javascript:;",
          "data-original-title": "",
          title: "Afficher / Cacher",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("span", { staticStyle: { "font-size": "22px" } }, [
        _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "width-min-nowrap" }, [
      _vm._v("$ suggéré"),
      _c("wbr"),
      _vm._v("unitaire"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "th",
      { staticClass: "text-left nowrap", staticStyle: { "max-width": "83px" } },
      [_vm._v("$ vendant"), _c("wbr"), _vm._v("unitaire")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }